module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datepicker"
  }, [(_vm.label) ? _c('label', {
    staticClass: "datepicker__label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('Datepicker', {
    attrs: {
      "input-class": _vm.addClass,
      "language": _vm.rusland,
      "format": "d MMMM yyyy",
      "monday-first": true,
      "name": _vm.name,
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "disabledDates": _vm.disabledDates,
      "highlighted": _vm.highlighted
    },
    on: {
      "selected": _vm.selectDate
    }
  }), (_vm.vError) ? _c('div', {
    staticClass: "datepicker__text"
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70bc7655","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Datepicker.vue
// module id = 261e95859402b3d5b520
// module chunks = 89